import { getClient } from './../utils/functions'

const specialLinks = [
  {
    type: 'Special link 1',
    label: 'Unsubscribe',
    link: 'http://[unsubscribe]/'
  },
  {
    type: 'Special link 1',
    label: 'Subscribe',
    link: 'http://[subscribe]/'
  },
  {
    type: 'Special link 1',
    label: 'Web Version',
    link: 'http://[webversion]/'
  },
  {
    type: 'Special link 2',
    label: 'Preference center',
    link: 'http://[preference_center]/'
  },
  {
    type: 'Special link 2',
    label: 'Homepage',
    link: 'http://[homepage]/'
  },
  {
    type: 'Special link 2',
    label: 'Contact',
    link: 'http://[contact]/'
  },  {
    type: 'Special link 2',
    label: 'Privacy',
    link: 'http://[privacy]/'
  },
]

const mergeTags = [
  { name: 'Name', value: 'name' },
  { name: 'Surname', value: 'surname' },
  { name: 'Email', value: 'email' },
  { name: 'Address', value: 'address' },
  { name: 'Username', value: 'username' },
  { name: 'Company', value: 'company' },
  { name: 'Job title', value: 'job_title' },
  { name: 'Subscription tier', value: 'subscription_tier' },
  { name: 'Role', value: 'role' },
  { name: 'Current Date', value: 'current_date' },
  { name: 'Price', value: 'price' },
  { name: 'Device', value: 'device' },
  { name: 'Location', value: 'location' },
  { name: 'Phone number', value: 'phone_number' },
  { name: 'Product', value: 'product' },
  { name: 'Verification code', value: 'verification_code' }, 
  { name: 'Country', value: 'country' },
  { name: 'City', value: 'city' }
]

const mergeContents = [{
  name: 'first custom content',
  value: '{custom-content-1}'
}, {
  name: 'second custom content',
  value: '{custom-content-2}'
}, {
  name: 'third custom content',
  value: '{custom-content-3}'
}]

const rowDisplayConditions = [{
  type: 'Product Loop',
  label: 'Loops',
  description: 'This demo uses handlebars.js.  You can use the values {{price}} and {{name}}',
  before: '{{#each products}}',
  after: '{{/each}}',
}, {
  type: 'Customer Loop',
  label: 'Loops',
  description: 'This demo uses handlebars.js.  You can use the value {{FirstName}}.',
  before: '{{#each customer}}',
  after: '{{/each}}',
}, {
  type: 'Countries',
  label: 'Italy',
  description: 'Only recipients from Italy will see the row',
  before: '{% if user.country == \'Italy\' %}',
  after: '{% endif %}',
}, {
  type: 'Countries',
  label: 'Italia',
  description: 'Solo i destinatari italiani vedranno questa riga',
  before: '{% if user.country == \'Italy\' %}',
  after: '{% endif %}',
}, {
  type: 'Countries',
  label: 'France',
  description: 'Only recipients from France will see the row',
  before: '{% if user.country == \'France\' %}',
  after: '{% endif %}',
}, {
  type: 'Countries',
  label: 'France',
  description: 'Only recipients from France will see the row',
  before: '{% if user.country == \'Francia\' %}',
  after: '{% endif %}',
}, {
  type: 'Countries',
  label: 'Spain',
  description: 'Only recipients from Spain will see the row',
  before: '{% if user.country == \'Spain\' %}',
  after: '{% endif %}',
}, {
  type: 'Countries',
  label: 'Germany',
  description: 'Only recipients from Germany will see the row',
  before: '{% if user.country == \'Germany\' %}',
  after: '{% endif %}',
}, {
  type: 'Countries',
  label: 'Portugal',
  description: 'Only recipients from Portugal will see the row',
  before: '{% if user.country == \'Portugal\' %}',
  after: '{% endif %}',
}, {
  type: 'People',
  label: 'Person is a Man',
  description: 'Check if a person is a Man',
  before: "{if gender == 'Male'}",
  after: '{endif}'
}, {
  type: 'People',
  label: 'Person is a Woman',
  description: 'Check if a person is a Woman',
  before: "{if gender == 'Famale'}",
  after: '{endif}'
}]


const client = getClient()

const rowsConfiguration = {
  emptyRows: true,
  defaultRows: true,
  externalContentURLs: [{
    name: 'My saved rows',
    value: `${client.demoAPI}/feedRows`
  }]
}

const customAttributes = {
  attributes: [
    {
      key: 'data-segment',
      value: ['1.2', '1.3'],
      target: 'link'
    },
    {
      key: 'class',
      target: 'tag'
    },
    {
      key: 'class',
      target: 'link'
    }
  ]
}

const Settings = {
  customCss: '',
  mergeTags,
  specialLinks,
  mergeContents,
  rowDisplayConditions,
  rowsConfiguration,
  customAttributes,
}

export default Settings
